import Seo from '@/components/feature/Seo';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntries from '@/pages/home/components/CategoryEntries';
import LatestMovies from '@/pages/home/components/LatestMovies';
import LatestNews from '@/pages/home/components/LatestNews';
import SiteIntro from '@/pages/home/components/SiteIntro';

export default function Home() {
  return (
    <>
      <Seo
        title="奸情影视大全-最新电影电视剧剧情介绍与影视资讯"
        description="奸情影视大全提供全面的电影、电视剧剧情介绍和影视资讯，覆盖各类与奸情相关的影视作品，帮助用户了解剧情详情和演员信息。"
        keywords="奸情,影视大全,电影,电视剧,剧情介绍,奸情影视,影视资讯,演员"
      />
      <HeroCarousel />
      <div className="flex flex-col gap-16 py-14">
        <CategoryEntries />
        <LatestMovies />
        <LatestNews />
        <SiteIntro />
      </div>
    </>
  );
}